import { render } from "./vatInvoice.vue?vue&type=template&id=0abc68a0&scoped=true"
import script from "./vatInvoice.vue?vue&type=script&lang=js"
export * from "./vatInvoice.vue?vue&type=script&lang=js"

import "./vatInvoice.vue?vue&type=style&index=0&id=0abc68a0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abc68a0"]])

export default __exports__